<!-- 扣费记录 -->
<template>
  <div>
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户手机号">
              <a-input placeholder="请输入用户手机号" v-model="queryParam.userPhone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="操作类型">
                <a-select
                  style="width: 100%"
                  placeholder="请选择操作类型"
                  v-model="queryParam.accountChangeType"
                >
                  <a-select-option v-for="(item,value) in accountChangeObj" :value="value" :key="value">
                    {{item}}
                  </a-select-option>
                </a-select>
            </a-form-item>
            </a-col>
            <a-col :xl="8" :lg="7" :md="8" :sm="24">
                <a-form-item label="查询起止时间">
                    <a-range-picker
                    v-model="accountChangeDate"
                    format="YYYY-MM-DD"
                    :placeholder="['查询起始时间', '查询结束时间']"
                    @change="onDateRangeChangeAccountChange"
                    />
                </a-form-item>
            </a-col>
            <a-col :xl="4" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                </span>
            </a-col>
        </a-row>
      </a-form>
    </div> -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">
      </a-table>
    </div>
  </div>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import {isUndefined,isNull,isUndefinedAndNull} from'@/utils/validate'
  import {payWayObj,payTypeObj,meterTypeObj,accountChangeObj} from '@/utils/constants/commonConstant'

  export default {
    name: 'DeductionRecord',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      JInput
    },
    props:{
      id:{
        type: String,
        default: ''
      }
    },
    data () {
      return {
        accountChangeObj,
        url: {
          list: "/jeecg-charge/meter/meterUserAccountChangeRecord/list",
        },
        queryParam: {},
        accountChangeDate: [],
      }
    },
    watch:{
      id(val){
        if(val){
          this.loadData();
        }
      }
    },
    created() {},
    mounted(){},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 120
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId',
            width:120
          },{
            title: this.$t('上期累计(m³)'),
            align:"center",
            dataIndex: 'userPreWaterNum',
            customRender: (t,r,index) => {
              return isNull(t)?'--':t;
            }
          },{
            title: this.$t('上期余额(元)'),
            align:"center",
            dataIndex: 'userPreAccountNum',
            customRender: (t,r,index) => {
              return isNull(t)?'--':t;
            }
          },{
            title: this.$t('本期累计(m³)'),
            align:"center",
            dataIndex: 'userNowWaterNum',
            customRender: (t,r,index) => {
              return isNull(t)?'--':t;
            }
          },{
            title: this.$t('本期使用(m³)'),
            align:"center",
            dataIndex: 'userChangeWaterNum',
            customRender: (t,r,index) => {
              return isNull(t)?'--':t;
            }
          },{
            title: this.$t('金额变动(元)'),
            align:"center",
            dataIndex: 'userChangeAccountNum',
            customRender: (t,r,index) => {
              if(!isUndefined(r.userAccountChangeType)&&[4,5,7,19].includes(r.userAccountChangeType)) {
                return '-'+t
              }
              return t
            }
          },{
            title: this.$t('本期余额(元)'),
            align:"center",
            dataIndex: 'userNowAccountNum'
          },{
            title: this.$t('计费时间'),
            align:"center",
            dataIndex: 'createTime',
          },{
            title: this.$t('操作人'),
            align:"center",
            dataIndex: 'createBy'
          },{
            title: this.$t('操作类型'),
            align:"center",
            dataIndex: 'userAccountChangeType',
            customRender: (t,r,index) => {
              let obj = accountChangeObj
              if(isUndefined(obj[t])) {
                return this.$t('其他')
              }
              return this.$t(obj[t])
            }
          }
        ]
      }
    },
    methods: {
      loadData(){
        var params = this.getQueryParams();//查询条件
        params.userId = this.id;
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      onDateRangeChangeAccountChange(value, dateStrings) {
        if(dateStrings[0]!=''&&dateStrings[1]!='') {
          this.queryParam.beginDate = dateStrings[0];
          this.queryParam.endDate = dateStrings[1];
        }else{
          if(this.queryParam['beginDate']) {
            delete this.queryParam['beginDate']
          }
          if(this.queryParam['endDate']) {
            delete this.queryParam['endDate']
          }
        }
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>